// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"342b6773","150":"74177f1d","196":"0c15954a","229":"03ce4516","423":"4dbe11a6","453":"a04ae9d0","556":"1412d457","557":"1cbab444","624":"a5578ac4","649":"292c4452","693":"e8cd4788","905":"ea469466"}[chunkId] + ".chunk.js";
};